export const INNER_CONTENT_DESKTOP_MAX_WIDTH = '1110px';
